import React from "react"
import Typography from "@material-ui/core/Typography"
import Layout from "../components/layout"
import woi from "./underconstruction.jpeg"
const WorkingOnIt = props => (
  <Layout>
    <div style={{ backgroundColor: "#000000", borderRadius: "50%",  color: 'white', height: 562 }}>
      <div
        style={{ margin: "50px auto", textAlign: "center", paddingTop: 130 }}
      >
        <Typography variant="h6">...trabajando en ello...</Typography>
        <div
          style={{
            backgroundColor: "transparent",
            borderRadius: 12,
            margin: "0 auto",
          }}
        >
          <img
            src={woi}
            alt=""
            style={{ borderRadius: "50% 50%" }}
            className="spreaded"
          />
        </div>
        <p>{props.children}</p>
      </div>
      <p style={{margin: '0 auto', width: '300px', textAlign:'center', paddingBottom: '24px'}}>
        Estamos construyendo el blog. Pronto habrá acá artículos y novedades escritos por el equipo de Fiammengo SRL.
      </p>
    </div>
  </Layout>
)

export default WorkingOnIt
